import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;
function ItemSucursalCajaCierre(props) {
    const { sucursal,fecha,idEmpleado,actualizar } = props;
    const [cargando, setCargando] = useState(false);
    const [datosd, setDatosd] = useState([]);
    const [datosn,setDatosn] = useState([]);
    const [error, setError] = useState({});
    function getInventario() {
        setCargando(true);
        fetch(`${server}/reporte/obtenerInvTurno`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                 ...sucursal, idAlmacen: 1, fecha, idEmpleado
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setDatosd(data.ok.MA);
                    setDatosn(data.ok.TA);
                } else {
                    setError({ error: 'ERR' })
                }
                setCargando(false);
            })
            .catch(error => MsgUtils.msgError(error));
    }
    function getDatos(turno,tipo){
        var datos=[]
        if(tipo=='P'){
            if(turno=='M'){
                datos= datosd.filter((item)=>[10,11,12,13].indexOf(parseInt(item.ID_PROD_ORIGINAL)) !== -1);
            }else{
                datos= datosn.filter((item)=>[10,11,12,13].indexOf(parseInt(item.ID_PROD_ORIGINAL)) !== -1);
            }
        }else if(tipo=='L'){
            if(turno=='M'){
                datos= datosd.filter((item)=>[134].indexOf(parseInt(item.ID_PROD_ORIGINAL)) !== -1);
            }else{
                datos= datosn.filter((item)=>[134].indexOf(parseInt(item.ID_PROD_ORIGINAL)) !== -1);
            }
        }else if(tipo=='A'){
            if(turno=='M'){
                datos= datosd.filter((item)=>[121].indexOf(parseInt(item.ID_PROD_ORIGINAL)) !== -1);
            }else{
                datos= datosn.filter((item)=>[121].indexOf(parseInt(item.ID_PROD_ORIGINAL)) !== -1);
            }
        }else if(tipo=='F'){
            if(turno=='M'){
                datos= datosd.filter((item)=>[122].indexOf(parseInt(item.ID_PROD_ORIGINAL)) !== -1);
            }else{
                datos= datosn.filter((item)=>[122].indexOf(parseInt(item.ID_PROD_ORIGINAL)) !== -1);
            }
        }else if(tipo=='H'){
            if(turno=='M'){
                datos= datosd.filter((item)=>[110,112,113,114,166,167].indexOf(parseInt(item.ID_PROD_ORIGINAL)) !== -1);
            }else{
                datos= datosn.filter((item)=>[110,112,113,114,166,167].indexOf(parseInt(item.ID_PROD_ORIGINAL)) !== -1);
            }
        }else if(tipo=='J'){
            if(sucursal.CAMPO!=null||sucursal.CAMPO!=undefined){
                if(turno=='M'){
                    datos= datosd.filter((item)=>[1040,1041,1042].indexOf(parseInt(item.ID_PROD_ORIGINAL)) !== -1);
                }else{
                    datos= datosn.filter((item)=>[1040,1041,1042].indexOf(parseInt(item.ID_PROD_ORIGINAL)) !== -1);
                }
            }else{
                if(turno=='M'){
                    datos= datosd.filter((item)=>[158,159,160].indexOf(parseInt(item.ID_PROD_ORIGINAL)) !== -1);
                }else{
                    datos= datosn.filter((item)=>[158,159,160].indexOf(parseInt(item.ID_PROD_ORIGINAL)) !== -1);
                }
            }
        }
        var ventas = datos.map(item=>item.VENTAS_ORIGINAL);
        return ventas.reduce((a, b) => a + b, 0);
    }
    useEffect(() => {
        if(fecha!=''){
            getInventario();
        }
    }, [actualizar])
    return (
        <tr>
            <th>{sucursal.SUCURSAL}</th>
            {cargando && [1, 2, 3, 4 ,5,6,7,8,9,10,11,12].map((item) => {
                return (
                    <td className='text-center' key={item} style={{ fontSize: '19px', width: '100px' }}><i className="fa-solid fa-spinner fa-spin"></i></td>
                )
            })}
            {!cargando && error.error !== undefined && [1, 2, 3, 4,5,6,7,8,9,10,11,12].map((item) => {
                return (
                    <td className='text-center' style={{ fontSize: '19px', width: '100px' }}><span className='badge rounded-pill btnActivo'>{error.error}</span></td>
                )
            })}
            {!cargando && error.error == undefined && <td className='text-center'>{getDatos('M','P')}</td>}
            {!cargando && error.error == undefined && <td className='text-center'>{getDatos('T','P')}</td>}
            {!cargando && error.error == undefined && <td className='text-center'>{getDatos('M','L')}</td>}
            {!cargando && error.error == undefined && <td className='text-center'>{getDatos('T','L')}</td>}
            {!cargando && error.error == undefined && <td className='text-center'>{getDatos('M','A')}</td>}
            {!cargando && error.error == undefined && <td className='text-center'>{getDatos('T','A')}</td>}
            {!cargando && error.error == undefined && <td className='text-center'>{getDatos('M','F')}</td>}
            {!cargando && error.error == undefined && <td className='text-center'>{getDatos('T','F')}</td>}
            {!cargando && error.error == undefined && <td className='text-center'>{getDatos('M','H')}</td>}
            {!cargando && error.error == undefined && <td className='text-center'>{getDatos('T','H')}</td>}
            {!cargando && error.error == undefined && <td className='text-center'>{getDatos('M','J').toFixed(2)}</td>}
            {!cargando && error.error == undefined && <td className='text-center'>{getDatos('T','J').toFixed(2)}</td>}
        </tr>
    )
}

export default ItemSucursalCajaCierre